angular.module 'zc.users'

.controller 'EditUserPasswordCtrl', ($scope, $stateParams, $translate, Page, Devise) ->
  Page.setBodyClass ''

  $translate('users.controllers.password.editPassword').then (translation) ->
    Page.setTitle translation

  $scope.user = {
    current_password: '',
    password: '',
    password_confirmation: '',
  };
  $scope.isSaving = false;

  $scope.save = (user) ->
    $scope.isSaving = true;
    # make sure passwords match
    if $scope.user.password isnt $scope.user.password_confirmation
      alertify.error $translate.instant('users.controllers.password.passwordMismatch')
      $scope.isSaving = false;
      $scope.form.$setPristine()
      return

    Devise.updatePassword user.current_password, user.password, user.password_confirmation
    .then ->
      #empty password fields if update succesful
      $scope.user = {}
    .finally ->
      $scope.isSaving = false;
      $scope.form.$setPristine()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/controllers/password/edit_password_controller.js.coffee